import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';

// todo: could be better placed
import { ZxcvbnLoad } from '../../zxcvbn-load';

@Component({
  selector: 'strength-meter',
  templateUrl: './strength-meter.component.html',
  styleUrls: ['./strength-meter.component.css'],
})
export class StrengthMeterComponent implements OnInit, OnChanges {
  @Input()
  password: string = '';

  @Output('strength')
  passwordStrength = new EventEmitter();

  strength: number = 0;
  crack_times_display: {};
  private zxcvbn;

  constructor() {}

  ngOnInit() {
    ZxcvbnLoad.asyncLoad().then((zxcvbn) => {
      this.zxcvbn = zxcvbn;
      this.getStrength(this.password);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['password'];
    if (change) {
      this.getStrength(change.currentValue);
    }
  }

  getStrength(password) {
    if (this.zxcvbn) {
      const estimation = this.zxcvbn(password || '');
      this.strength = estimation.score;
      this.crack_times_display = estimation.crack_times_display;
      this.passwordStrength.emit({
        strength: this.strength,
      });
    }
  }

  getClass() {
    return `level-${this.strength}`;
  }
}
